<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center">
          {{ $t("string.msg.footer.text") }}
          <a
            class="whatsapp-link"
            href="https://web.whatsapp.com/send?phone=5511999676510"
            target="_blank"
          >
          <img 
            src="https://i.imgur.com/ryESuZ5.png"
            data-selector="img">
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
</style>